<template>
	<div class="formInputGroup">
		<input 
			class="inputField"
			:type="type" 
			:name="label"
			:id="label"
			v-model="inputVal"
			@change="$emit('input', inputVal)"
			:class="{'hasValue' : inputVal != '' && inputVal != undefined, 'errorPresent': error != undefined && error != ''}"
		/>
		<span class="bar"></span>
		<label 
			class="inputLabel"
			:class="{'errorPresent' : error != undefined && error != ''}"
			:for="label"
		>
			{{label}}<span v-if="required" class="required-indicator"> *</span>
		</label>
		<span
			:class="{'errorPresent' : error != undefined && error != ''}"
			v-if="error != undefined && error != ''"
		>
			{{error}}
		</span>
	</div>
</template>

<script>

export default {
	name: 'InputField',
	props: ['label', 'value', 'type', 'error', 'required'],
	components: {

	},
	$_veeValidate: {
		// fetch the current value from the innerValue defined in the component data.
		name() {
			return this.label;
		},
		value () {
			return this.inputVal;
		}
	},
	computed: {
		inputVal: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
